import { KeyValueStorage, StorageActions } from "./types";

/**
 * This function provides a set of actions (get, set, remove) for each key in the storage.
 * @param keys  
 * @param storage 
 * @returns 
 */

export const createStorageController = <T extends string>(
    keys: readonly T[],
    storage: KeyValueStorage
): Record<T, StorageActions> => {
    return keys.reduce((acc, key) => {
        acc[key] = {
            get: async () => storage.get(key),
            set: async (value: string) => storage.set(key, value),
            remove: async () => storage.remove(key)
        };
        return acc;
    }, {} as Record<T, StorageActions>);
};